import ImmutablePropTypes from 'react-immutable-proptypes';
const TeamsProp = ImmutablePropTypes.map.isRequired;
export const HierarchalTeamsProp = ImmutablePropTypes.set.isRequired;
export default TeamsProp;